import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { Crown } from "lucide-react";

// Images
import img1 from "../images/video_thumbnails/thumb1.jpg";
import img2 from "../images/video_thumbnails/thumb2.jpg";
import img3 from "../images/video_thumbnails/thumb3.jpeg";
import img4 from "../images/video_thumbnails/thumb4.jpeg";
import img5 from "../images/video_thumbnails/thumb5.jpeg";
import img6 from "../images/video_thumbnails/thumb6.jpeg";
import img7 from "../images/video_thumbnails/thumb7.jpg";

const thumbnails = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
];

export default function LezioneCard({ title, subtitle, lessonId, premium }) {
    const navigate = useNavigate();

    const randomThumbnail = useMemo(() => {
        const index = Math.floor(Math.random() * thumbnails.length);
        return thumbnails[index];
    }, []);

    const handleCardClick = () => {
        navigate(`/lezioni/${lessonId}`);
    };

    return (
        <div
            className="bg-black text-white p-4 rounded-lg w-full max-w-lg cursor-pointer"
            onClick={handleCardClick}
        >
            <div className="flex">
                {/* Thumbnail */}
                <div className="bg-gray-900 w-32 h-20 rounded-lg relative flex-shrink-0 overflow-hidden">
                    <img
                        src={randomThumbnail}
                        alt="Thumbnail"
                        className="w-full h-full object-cover rounded-lg"
                    />
                </div>

                {/* Subtitle + Premium Icon */}
                <div className="ml-4 flex flex-col justify-between w-full">
                    <div className="flex items-start justify-between">
                        <p className="text-sm text-gray-300">{subtitle}</p>
                        {premium && (
                            <Crown
                                className="text-yellow-400 w-5 h-5 flex-shrink-0"
                                title="Contenuto Premium"
                            />
                        )}
                    </div>
                </div>
            </div>

            {/* Title */}
            <div className="mt-3">
                <h2 className="text-lg font-semibold">{title}</h2>
            </div>
        </div>
    );
}